import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiVisa, BaseApiTemplateService, BasicApiResponseModel, Core2Config, Pagination, PagingResponseModel} from '../../shared';
import {PowerSearchContainerModel} from '../../../../../../models';
import { Observable } from 'rxjs';

@Injectable({providedIn: 'root'})

export class PowerSearchService extends BaseApiTemplateService<PowerSearchContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CPCOMMERCE_PREFIX + 'search-filter/power-search/public-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CPCOMMERCE_PREFIX + 'search-filter/power-search/public-ep';
    this.httpClient = http;
  }

  public getByCriteriaAdvancedSearchPublicEp(pagination: Pagination, visa: ApiVisa, criteria?: any): Observable<PagingResponseModel<PowerSearchContainerModel>> {
    if (visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CPCOMMERCE_PREFIX + 'search-filter/power-search/entity-branch/advanced-search/public-ep';
    }
    else {
      this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CPCOMMERCE_PREFIX + 'search-filter/power-search/entity-branch/advanced-search/public-ep';
    }
    const UrlByCriteria = this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<PowerSearchContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  public getSlimListingByCriteria(
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Observable<PagingResponseModel<PowerSearchContainerModel>> {
    let apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CPCOMMERCE_PREFIX + 'search-filter/power-search/public-ep/slim-listing';
    if (visa.api_domain_url) {
      apiUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CPCOMMERCE_PREFIX + 'search-filter/power-search/public-ep/slim-listing';
    }
    const UrlByCriteria =
      apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<PowerSearchContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  public getTotalRecordByCriteria(
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Observable<BasicApiResponseModel<any>> {
    let apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CPCOMMERCE_PREFIX + 'search-filter/power-search/public-ep/slim-listing';
    if (visa.api_domain_url) {
      apiUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CPCOMMERCE_PREFIX + 'search-filter/power-search/public-ep/slim-listing';

    }
    const UrlByCriteria =
      apiUrl + '/count?' + pagination.getQueryKeyValues();
    return this.httpClient.get<BasicApiResponseModel<any>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  public getListingByEntityBranch(
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Observable<PagingResponseModel<PowerSearchContainerModel>> {
    let apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CPCOMMERCE_PREFIX + 'search-filter/power-search/entity-branch/public-ep';
    if (visa.api_domain_url) {
      apiUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CPCOMMERCE_PREFIX + 'search-filter/power-search/entity-branch/public-ep';
    }
    const UrlByCriteria =
      apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<PowerSearchContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }


}

/* ===== QUERY =====
COMPULSORY
website_guid
label_hdr_guids
======================
OPTIONAL
attribute search
&attribute_hdr_guids=345678&value_string=4567 or
&attribute_hdr_guids=345678&value_numerics=4567
===========================
Pricing search
&from_unit_price=1000&to_unit_price=1999
===============================
rewords
&reward_point=23456
&redeem_point=1234567
=================================
point_ccy_guids=
review_hdr_guids=
stock_available=true/false
=============================
core2/tnt/dm/search-filter/power-search/backoffice-ep/header/query
return only
bl_fi_mst_item_hdr
bl_fi_mst_ecomsync_item_hdr

 */
